<template>
  <div class="container1">
    <h2>CPU&nbsp;渲染</h2>
    <div class="cpu-list">
      <el-row class="count-list">
        <el-col class="flex-center" :xs="12" :sm="12" :md="6" :lg="6" :xl="6" v-for="(item, index) in cpuList" :key="index">
          <div class="text-group_6 flex-row">
            <div class="text-group_2 flex-col justify-between">
              <div class="text-wrapper_2 flex-row justify-between">
                <span class="text_12">{{item.num}}</span> <span class="text_13">线程</span>
              </div>
              <span class="text_14">{{item.text1}}</span>
              <span class="text_19">{{item.text2}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <h2>GPU&nbsp;渲染</h2>
    <div class="cpu-list">
      <el-row class="count-list">
        <el-col class="flex-center" :xs="12" :sm="12" :md="6" :lg="6" :xl="6" v-for="(item, index) in gpuList" :key="index">
          <div class="text-group_10 flex-row">
            <div class="text-group_2 flex-col justify-between">
              <div class="text-wrapper_6">
                <span class="text_29">{{item.text1}}</span>
                <img
                  class="thumbnail_1"
                  referrerpolicy="no-referrer"
                  src="../../assets/image/price-multi.png"/>
                <span class="text_32">{{item.num}}</span>
              </div>
              <span class="text_31 flex-center">{{item.text2}}</span>

            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="text_42">内存默认为：64GB。128GB加收20%，256GB加收60%。</div>
  </div>
</template>

<script>
export default {
  name: "price4",
  data(){
    return {
      cpuList: [
        {
          num: 40,
          text1: "20核心/40线程",
          text2: "2.0元/机时"
        },
        {
          num: 48,
          text1: "24核心/48线程",
          text2: "2.4元/机时"
        },
        {
          num: 56,
          text1: "28核心/56线程",
          text2: "2.8元/机时"
        },
        {
          num: 64,
          text1: "32核心/64线程",
          text2: "3.2元/机时"
        }
      ],
      gpuList: [
        {
          num: 1,
          text1: "1080Ti",
          text2: "3.0元/卡时"
        },
        {
          num: 2,
          text1: "3060",
          text2: "3.5元/卡时"
        },
        {
          num: 2,
          text1: "3090",
          text2: "10.0元/卡时"
        },
        {
          num: 4,
          text1: "3090",
          text2: "8.0元/卡时"
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
